/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import RoundedButton from '../buttons/Rounded';
import WolfGreen from '../icons/2024/WolfGreen';
import ArrowIcon from '../icons/Arrow';
import Image from '../partials/Image';

import styles from '../../../styles/slides/article.module.scss';

const propTypes = {
    item: PropTypes.shape({
        article: AppPropTypes.article,
    }),
    className: PropTypes.string,
    isDragging: PropTypes.bool,
    isCurrent: PropTypes.bool,
};

const defaultProps = {
    item: null,
    className: null,
    isDragging: false,
    isCurrent: false,
};

const ArticleSlide = ({ item, className, isDragging, isCurrent }) => {
    const { article = null } = item || {};
    const { title = null, description = null, image = null, url = null } = article || {};
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.isCurrent]: isCurrent,
                    [styles.isDragging]: isDragging,
                },
            ])}
        >
            {image !== null ? (
                <Image
                    className={styles.visual}
                    imageClassName={styles.image}
                    mediaSize="cover"
                    media={image}
                    cover
                    fit
                />
            ) : (
                <WolfGreen className={styles.imagePlaceholder} color="#212121" />
            )}
            <div className={styles.content}>
                {title !== null && <h3 className={styles.heading}>{title}</h3>}
                {description !== null && <p className={styles.description}>{description}</p>}
                {url !== null && (
                    <RoundedButton
                        className={styles.button}
                        href={url}
                        icon={<ArrowIcon />}
                        iconPosition="right"
                        tabIndex={!isCurrent ? '-1' : null}
                    >
                        <FormattedMessage
                            defaultMessage="Read the article"
                            description="Button label"
                        />
                    </RoundedButton>
                )}
            </div>
        </div>
    );
};

ArticleSlide.propTypes = propTypes;
ArticleSlide.defaultProps = defaultProps;

export default ArticleSlide;
